import $ from 'jquery';

import L from 'leaflet/dist/leaflet';

export function leaflet_init(classes = ".our-map") {
  if ($(classes).length > 0) {
    $(classes).each(function () {
      var marker = "";
      var oMap = $(this);
      var idMap = $(this).attr('id');
      var markers = [];
      var latN = "";
      var lngN = "";
      var zoom = $(this).data('zoom');
      var icon = $(this).data('icon');
      var shadowIcon = $(this).data('shadow-icon');
      var description = "";
      var icoWidth = $(this).data('icowidth');
      var icoHeight = $(this).data('icoheight');
      var icoAnchorLeft = "";
      var icoAnchorRight = "";
      var main_LatN = $(this).data('center-lat');
      var main_lngN = $(this).data('center-lng');
      var flys = [];
      var myMap = L.map(idMap);

      // load a tile layer
      L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoidnJvb20tbWFwYm94IiwiYSI6ImNrbWRsZTExZjJhcjEyem16czgwZTJ4NjEifQ.ydl7YyAcVberxWuQx8wUdA', {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        id: 'mapbox/streets-v11',
      }).addTo(myMap);

      oMap.find('.woody-marker').each(function () {

        latN = Number($(this).data('map-lat'));
        lngN = Number($(this).data('map-lng'));
        zoom = Number($(this).data('map-zoom'));
        description = $(this).data('map-description');
        if ($(this).data('map-main') == '1') {
          main_LatN = Number($(this).data('map-lat'));
          main_lngN = Number($(this).data('map-lng'));
        }
        if (latN !== "" && lngN !== "") {
          var myIcon = L.icon({
            iconUrl: icon,
            iconSize:     [50, 41],
            iconAnchor:   [25, 41],
          });
          var marker = L.marker([latN, lngN], {icon: myIcon}).addTo(myMap);
          if(description != ''){
            marker.bindPopup(description);
          }
        }
      });

      myMap.scrollWheelZoom.disable();
      myMap.setView([main_LatN, main_lngN], zoom);
      $(classes).find("a").addClass('nude');
    });
  }
}
$(document).ready(function () {
  leaflet_init();
});
